import React, { useState } from 'react'
import { useSelector } from 'react-redux'
import { Link } from 'react-router-dom'
import {
  allCrudNames,
  allPages,
  checkPageAccess
} from '../../../lib/AllPageNames'
import NotFound from '../../NotFound/NotFound'
import ManageLayoutOption from './ManageLayoutOption'
import ManageLayoutType from './ManageLayoutType'
import ManageLayoutTypeDetails from './ManageLayoutTypeDetails'
import ManageMainLayout from './ManageMainLayout'

const ManageLayout = () => {
  const [activeToggle, setActiveToggle] = useState('layout')

  const handleTabClick = (e, tabName) => {
    e.preventDefault()
    setActiveToggle(tabName)
  }

  // useEffect(() => {
  //   titleOfTab(activeToggle)
  // }, [activeToggle]);
  const { pageAccess } = useSelector((state) => state.user)

  return checkPageAccess(
    pageAccess,
    allPages?.manageLayout,
    allCrudNames?.read
  ) ? (
    <>
      <div className='card overflow-hidden'>
        <div className='card-body p-0'>
          {/* Tabs Links */}
          <div className='nav-tabs-horizontal nav nav-tabs'>
            {checkPageAccess(
              pageAccess,
              allPages?.manageLayout,
              allCrudNames?.read
            ) && (
              <>
                <Link
                  onClick={(e) => handleTabClick(e, 'layout')}
                  data-toggle='tab'
                  className={`nav-link fw-semibold ${
                    activeToggle === 'layout' ? 'active show' : ''
                  }`}
                >
                  <span className='nav-span'>
                    Layout
                    <hr />
                  </span>
                </Link>
                <Link
                  onClick={(e) => handleTabClick(e, 'layout-type')}
                  data-toggle='tab'
                  className={`nav-link fw-semibold ${
                    activeToggle === 'layout-type' ? 'active show' : ''
                  }`}
                >
                  <span className='nav-span'>
                    Layout Type
                    <hr />
                  </span>
                </Link>
                <Link
                  onClick={(e) => handleTabClick(e, 'layout-type-details')}
                  data-toggle='tab'
                  className={`nav-link fw-semibold ${
                    activeToggle === 'layout-type-details' ? 'active show' : ''
                  }`}
                >
                  <span className='nav-span'>
                    Layout Type Details
                    <hr />
                  </span>
                </Link>
                <Link
                  onClick={(e) => handleTabClick(e, 'layout-option')}
                  data-toggle='tab'
                  className={`nav-link fw-semibold ${
                    activeToggle === 'layout-option' ? 'active show' : ''
                  }`}
                >
                  <span className='nav-span'>
                    Layout Option
                    <hr />
                  </span>
                </Link>
              </>
            )}
          </div>
          {checkPageAccess(
            pageAccess,
            allPages?.manageLayout,
            allCrudNames?.read
          ) && (
            <div className='tab-content p-3'>
              <div
                id='layout'
                className={`tab-pane fade ${
                  activeToggle === 'layout' ? 'active show' : ''
                }`}
              >
                {activeToggle === 'layout' && <ManageMainLayout />}
              </div>
              <div
                id='layout-type'
                className={`tab-pane fade ${
                  activeToggle === 'layout-type' ? 'active show' : ''
                }`}
              >
                {activeToggle === 'layout-type' && <ManageLayoutType />}
              </div>
              <div
                id='layout-type'
                className={`tab-pane fade ${
                  activeToggle === 'layout-type-details' ? 'active show' : ''
                }`}
              >
                {activeToggle === 'layout-type-details' && (
                  <ManageLayoutTypeDetails />
                )}
              </div>
              <div
                id='layout-option'
                className={`tab-pane fade ${
                  activeToggle === 'layout-option' ? 'active show' : ''
                }`}
              >
                {activeToggle === 'layout-option' && <ManageLayoutOption />}
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  ) : (
    <NotFound />
  )
}

export default ManageLayout
